import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from './plugins/vuetify'
import i18n from "./plugins/i18n"
import linkify from 'vue-linkify'
import VueMask from "v-mask"
import RessourceInfoBulle from './components/common/RessourceInfoBulle'
import InputFacade from 'vue-input-facade'

import { createVPhoneInput } from 'v-phone-input';
import VPhoneInputCSS from 'v-phone-input/dist/v-phone-input.css'
import FlagIconsCSS from 'flag-icons/css/flag-icons.min.css'

Vue.use(VueMask);
Vue.use(VPhoneInputCSS)
Vue.use(FlagIconsCSS)

const vPhoneInput = createVPhoneInput({
  countryIconMode: 'svg',
  defaultCountry: 'CA',
  preferredCountries: ['CA', 'US', 'BE', 'FR', 'CH'],
  countryLabel: 'Code',
  invalidMessage: ({ label, example }) =>
    `${label} doit être un numéro de téléphone valide (exemple: ${example}).`
})
Vue.use(vPhoneInput)

Vue.use(InputFacade);

Vue.directive('linkified', linkify)
//import { i18n } from './plugins/i18n';

Vue.component('RessourceInfoBulle', RessourceInfoBulle)

Vue.config.productionTip = true

// Plugins custom
require('./plugins/constants')
require('./plugins/filters.js')

export const vm = new Vue({
  router,
  i18n,
  store,
  vuetify,
  linkify,
  render: h => h(App)
}).$mount('#app')